export type LinkTab = {
  title: string
  link: string
}

export const forumHistoryNavs: LinkTab[] = [
  {
    title: 'Posts',
    link: '/forum/history'
  },
  {
    title: 'Comments',
    link: '/forum/history/comments'
  },
  {
    title: 'Announcements',
    link: '/forum/history/announcements'
  }
]

export const forumBookmarkNavs: LinkTab[] = [
  {
    title: 'Posts',
    link: '/forum/bookmark'
  },
  {
    title: 'Comments',
    link: '/forum/bookmark/comments'
  }
]

export const forumTagCategoryBreadcrumbs: LinkTab[] = [
  {
    title: 'Forum',
    link: '/forum/feed'
  },
  {
    title: 'Browse tags',
    link: '/forum/tag/browse'
  }
]

export const classForumStudentTabs: LinkTab[] = [
  {
    title: 'Posts',
    link: `/forum/class-forum/SLUG_HERE`
  },
  {
    title: 'Announcements',
    link: `/forum/class-forum/SLUG_HERE/announcements`
  },
  {
    title: 'Pinned ',
    link: `/forum/class-forum/SLUG_HERE/pinned`
  },
  {
    title: 'Support',
    link: `/forum/class-forum/SLUG_HERE/support`
  },
  {
    title: 'Instructors',
    link: `/forum/class-forum/SLUG_HERE/moderators`
  },
  {
    title: 'Students',
    link: `/forum/class-forum/SLUG_HERE/students`
  }
]
